import React, { useContext, useEffect } from 'react';
import { Column } from '../components/shared/Column';
import { Grid } from '../components/shared/Grid';

import { BaseLayout } from '../components/template/BaseLayout';
import { SurPlusStepper } from '../components/features/SurPlusStepper';
import { SurPlusCta } from '../components/features/SurPlusCta';
import { FormContext } from '../store/surplus/SurPlusContext';
import { SurPlusResult } from '../components/features/SurPlusResult';
import { Disclaimer } from '../components/features/Disclaimer/Disclaimer';
import { StepperContext } from '../store/stepper/StepperContext';
import { isLocal } from '../utils';

export const Home = () => {
	const { data, consumer } = useContext(FormContext);
	const { state } = useContext(StepperContext);
	const { steps } = state;

	useEffect(() => {
		if (steps.length || data && consumer.status) {
			window.parent.postMessage({
				origin: 'https://www.hypotheker.nl',
				frameHeight: document.getElementById('root')?.clientHeight
			}, "*");
		}
	}, [steps, data]);

    return (
        <BaseLayout consumer={consumer}>
            <Grid>
							{!consumer.status &&
              <Column cols={[12, null, null, 5]}>
                <SurPlusCta/>
              </Column>
							}
							<Column cols={[12, null, null, (!consumer.status) ? 7 : 12]}>
								{data ? <SurPlusResult data={data} /> : null }
								<div hidden={!!data}>
								<SurPlusStepper />
								</div>
								{consumer.status &&
                <Disclaimer></Disclaimer>
								}
							</Column>
            </Grid>
        </BaseLayout>
    );
};
